export function getStorage(key: string, stringify = false): string | null {
    const item = localStorage.getItem(key);
    if (stringify) {
        return JSON.parse(item || "{}");
    }
    return item;
}

export function removeStorage(key: string): void {
    localStorage.removeItem(key);
}

export function gridjsSpanishLanguage() {
    return {
        search: {
            placeholder: "Ingrese una palabra",
        },
        sort: {
            sortAsc: 'Ordenar columna de forma ascendente',
            sortDesc: 'Ordenar columna de forma descendente',
        },
        pagination: {
            previous: 'Anterior',
            next: 'Siguiente',
            navigate: (page, pages) => `Página ${page} de ${pages}`,
            page: (page) => `Página ${page}`,
            showing: 'Mostrando',
            of: 'de',
            to: 'al',
            results: 'resultados',
        },
        loading: 'Cargando...',
        noRecordsFound: 'No se han encontrado registros coincidentes',
        error: 'Se ha producido un error al obtener los datos'
    };
}
